/* VersionControlGridViewRenderer.js */

"use strict";

const Registrations = require("../../../../../RegistrationNamespaces");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;

const _ = require("lodash");

class VersionControlGridViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("version-control-view-gl");
        this._logger = this._model.logger;
        this._defaultViewActive = false;
        this._versionControlEntityGrid = undefined;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._registerGridListeners();
        this._registerFeedListeners();
    }

    _registerFeedListeners() {
        this._model.pagingFeed.on(
            "RefreshView",
            (this._onFeedRefreshView = this._onFeedRefreshView.bind(this))
        );
        this._model.pagingFeed.on(
            "FeedInitialized",
            (this._onFeedInitialized = this._onFeedInitialized.bind(this))
        );
    }

    _registerGridListeners() {
        this._versionControlEntityGrid.on(
            "UserSelectedRows",
            (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this))
        );
        this._versionControlEntityGrid.on(
            "UserRowDoubleClicked",
            (this._onUserDblClickedRow = this._onUserDblClickedRow.bind(this))
        );
        this._versionControlEntityGrid.on(
            "UserSorted",
            (this._onUserSorted = this._onUserSorted.bind(this))
        );
        this._versionControlEntityGrid.on(
            "GridBusyStart",
            (this._onGridBusyStart = this._onGridBusyStart.bind(this))
        );
    }

    _unregisterListeners() {
        this._unregisterGridListeners();
        this._unregisterFeedListeners();
    }

    _unregisterFeedListeners() {
        if (this._model && this._model.pagingFeed) {
            this._model.pagingFeed.removeListener("RefreshView", this._onFeedRefreshView);
            this._model.pagingFeed.removeListener("FeedInitialized", this._onFeedInitialized);
        }
    }

    _unregisterGridListeners() {
        if (this._versionControlEntityGrid) {
            this._versionControlEntityGrid.removeListener(
                "UserSelectedRows",
                this._onGridUserSelectedRows
            );
            this._versionControlEntityGrid.removeListener(
                "UserRowDoubleClicked",
                this._onUserDblClickedRow
            );
            this._versionControlEntityGrid.removeListener("UserSorted", this._onUserSorted);
            this._versionControlEntityGrid.removeListener("GridBusyStart", this._onGridBusyStart);
        }
    }

    _renderAvailableActions() {}

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();

        let promArr = [_.invoke(this._versionControlEntityGrid, "shutdown") || Promise.resolve()];

        return Promise.all(promArr).then(
            () => {
                this._rootElem.remove();
                this._rootElem = undefined;
                this._model = undefined;
                this._logger = undefined;
                this._defaultViewActive = undefined;
                this._versionControlEntityGrid = undefined;
            },
            (error) => {
                this._logger.warn({error}, "VersionControlGridViewRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model._modalUserFeedback
            .displayLoading()
            .then(() => {
                return this._model.whenModelIsReady();
            })
            .then(() => {
                this._versionControlEntityGrid = new EntityGrid({
                    gridKey: this.model._gridKey,
                    logger: this._logger,
                    singleSelect: false,
                    columns: this._model.columnConfig,
                    pagingFeed: this._model._pagingVersionControlFeed,
                    selectedRows: _.get(this._model.getSelectedIds(), "selectedRows", []),
                    showHeader: true,
                    showLinesNumber: this._model._gameEditor.renderer._rootElem.querySelector(
                        "game-editor-view-actions-gl left-container"
                    ),
                    columnSettingsWidgetContainer:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    filterComponent:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    advancedFilterComponent:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    modalUserFeedback: this._model._modalUserFeedback,
                    userGridData: this._model._userGridData,
                });

                if (!this._rootElem.hasChildNodes()) {
                    this._rootElem.appendChild(this._versionControlEntityGrid.renderer.rootElement);
                }

                // this._renderAvailableActions();
                this._onFeedRefreshView();
                this._registerListeners();

                /*
                if (
                    this._model._gameEditor._openEditorFromUrl &&
                    (this._model._gameEditor._openEditorFromUrl.open ||
                        !_.isUndefined(this._model._gameEditor._openEditorFromUrl.selectedIds))
                ) {
                    _.get(this._model._gameEditor._openEditorFromUrl, "selectedIds", []).forEach(
                        (entityId) => {
                            let File = this._model.pagingFeed.getFileEntityById(entityId);
                            this._openEditor(File, entityId);
                        }
                    );
                }
                */

                if (this._model._gameEditor._filterFromUrl) {
                    this._policyEntityGrid._advancedFilter._advancedFilter._renderer._applyQuery();
                }

                this._model._modalUserFeedback.hideDisplayed();
            })
            .catch((err) => {
                this._logger.warn(err, "VersionControlGridViewRenderer.render() error");
                this._model._modalUserFeedback.displayError({
                    errorMsg: "The Version Explorer cannot be opened.",
                    errorCode: "",
                });
                return Promise.reject(err);
            });
    }

    get rootElement() {
        return this._rootElem;
    }

    get model() {
        return this._model;
    }

    get selectedRows() {
        return this._versionControlEntityGrid.getSelectedRows();
    }

    /*******************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS   */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _showDefaultMessageDisplay() {
        let message = {
            message: "No modified configurations to commit",
        };
        return this._model.gameEditor
            .showDefaultMessageView(message)
            .then(() => {
                this._defaultViewActive = true;
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "VersionControlGridViewRenderer._showDefaultMessageDisplay error"
                );
            });
    }

    _hideDefaultMessageDisplay() {
        return this._model.gameEditor
            .hideDefaultMessageView()
            .then(() => {
                this._defaultViewActive = false;
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "VersionControlGridViewRenderer._hideDefaultMessageDisplay error"
                );
            });
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onGridBusyStart() {
        if (this._model.pagingFeed.totalEntities > 50) {
            let gridBusyEnded = false;
            this._versionControlEntityGrid.once("GridBusyEnd", () => {
                gridBusyEnded = true;
            });
            this._model._modalUserFeedback.displayLoading().then(() => {
                if (gridBusyEnded) {
                    this._model._modalUserFeedback.hideDisplayed();
                } else {
                    this._versionControlEntityGrid.once("GridBusyEnd", () => {
                        this._model._modalUserFeedback.hideDisplayed();
                    });
                }
            });
        }
    }

    _onFeedInitialized() {
        // this._renderAvailableActions();
    }

    _onUserSorted(eventData) {
        this._model.onUserSorted(eventData);
    }

    _onUserDblClickedRow(obj) {
        this._model.openVersionControlInstanceEditor(
            obj.selectedRow,
            Registrations.VERSION_CONTROL_VIEW_DETAILS
        );
    }

    _onGridUserSelectedRows(selectedRowIds) {
        this._model.updateExplorerState("selectedIds", selectedRowIds || []);
        this._renderAvailableActions();
    }

    _onFeedRefreshView() {
        const totalEntities = this._model.pagingFeed.totalEntities;
        const filterData = this._model.pagingFeed.getFilterData();

        if (totalEntities === 0 && _.isEmpty(_.get(filterData, "$userQuery", filterData))) {
            if (this._defaultViewActive === false) {
                this._showDefaultMessageDisplay();
            }
        } else {
            if (this._defaultViewActive === true) {
                this._hideDefaultMessageDisplay();
            }
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    // TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = VersionControlGridViewRenderer;
